import router from "./routes";
import store from "./store";    
function isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}
const sortTasks = (payload) => {

    // Hardcode for sort by due date
    localStorage.setItem('storedSortKey', 'due_date');
    localStorage.setItem('storedSortFieldId', 12);
    localStorage.setItem('storedSortState', 'ASC');
    payload.sortKey = 'due_date';
    payload.fieldId = 12;
    payload.sortKey = 'ASC';
    payload.sortFields = false;

    let isDeliverableArray =  Array.isArray(payload.deliverables)
    if(!isDeliverableArray && typeof payload.deliverables.nextWeek == 'undefined') {
        payload.deliverables = [payload.deliverables]
    }
    let storedSortState = false
    let storedSortKey = localStorage.getItem('storedSortKey') 
    if(typeof payload.fieldId != 'undefined') {
        localStorage.setItem('storedSortFieldId', payload.fieldId)
        store.state.deliverables.storedSortFieldId = payload.fieldId
    } else {
        payload.fieldId = localStorage.getItem('storedSortFieldId')
    }
    if(!payload.sortKey) {
        if(storedSortKey) { // last set sort option by the user
            payload.sortKey = storedSortKey
            storedSortState = localStorage.getItem('storedSortState')
        } else { // default sorting === any sorting will not be applied to data
            localStorage.setItem('storedSortState', 'ASC')
            localStorage.setItem('nextSortState', 'DESC')
            localStorage.setItem('storedSortKey', 'created_date')
            store.state.deliverables.storedSortKey = 'created_date'
            store.state.deliverables.nextSortState = 'DESC'
            store.state.deliverables.storedSortState = 'ASC'
        }
    } else { 
        storedSortState = localStorage.getItem('nextSortState')
        if(!storedSortState || storedSortKey != payload.sortKey) {
            storedSortState = payload.sortKey == 'created_date' ? 'DESC' : 'ASC'
        } 
        localStorage.setItem('storedSortState', storedSortState)
        localStorage.setItem('nextSortState', storedSortState == 'ASC' ? 'DESC' : 'ASC')
        localStorage.setItem('storedSortKey', payload.sortKey)
        store.state.deliverables.storedSortKey = payload.sortKey
        store.state.deliverables.nextSortState = storedSortState
        store.state.deliverables.storedSortState = storedSortState
    }
    if(typeof payload.sortFields != 'undefined' && payload.sortFields) {
        sortTaskFields({})
    }
    if(payload.deliverables) {
        if(router.currentRoute.name == 'myWeek') {
            if(typeof payload.deliverables.nextWeek != 'undefined') {
                payload.deliverables = payload.deliverables.nextWeek.concat(payload.deliverables.noDeadline, payload.deliverables.overdue, payload.deliverables.thisWeek, payload.deliverables.today, payload.deliverables.upcoming)
            }
        }
        switch(payload.sortKey) {
            case 'created_date':
                localStorage.setItem('storedSortFieldId', null)  
                store.state.deliverables.storedSortFieldId = null
                let storedTaskOrder = store.state.deliverables.storedTaskOrder
                //console.log(storedTaskOrder)
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.sort((x, y) => {
                        if(storedSortState == 'ASC') {
                            if(storedTaskOrder !== null && typeof storedTaskOrder[deliverable.id] != 'undefined') {
                                var A = x['id'], B = y['id'];
                                return (storedTaskOrder[deliverable.id].indexOf(A) > storedTaskOrder[deliverable.id].indexOf(B)) ? 1 : -1
                                // return (x.id == y.display_order) ? 1 : -1
                            } else {
                                return (x.id > y.id) ? 1 : -1
                            }
                        } else {
                            if(storedTaskOrder !== null && typeof storedTaskOrder[deliverable.id] != 'undefined') {
                                var A = x['id'], B = y['id'];
                                return (storedTaskOrder[deliverable.id].indexOf(A) < storedTaskOrder[deliverable.id].indexOf(B)) ? 1 : -1
                                // return (x.display_order < y.display_order) ? 1 : -1
                            } else {
                                return (x.id < y.id) ? 1 : -1
                            }
                        }
                    })
                })
                break
            case 'user':
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.forEach((task, key) => {
                        task.taskFields.forEach((taskField, key) => {
                            deliverable.tasks.sort((x, y) => {
                                if(taskField.field_id != payload.fieldId) return
                                if(taskField.value != null && taskField.value != '') {
                                    if(storedSortState == 'ASC') {
                                        return (x.taskFields[key].userName.toUpperCase() > y.taskFields[key].userName.toUpperCase()) ? 1 : -1
                                    } else {
                                        return (x.taskFields[key].userName.toUpperCase() < y.taskFields[key].userName.toUpperCase()) ? 1 : -1
                                    }
                                }
                            })
                        })
                    })
                })
                break
            case 'status':
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.forEach((task, key) => {
                        task.taskFields.forEach((taskField, key) => {
                            deliverable.tasks.sort((x, y) => {
                                if(taskField.field_id != payload.fieldId) return
                                if(taskField.value != null && taskField.value != '') {
                                    if(isJSON(x.taskFields[key].value)) {
                                        x.taskFields[key].value = JSON.parse(x.taskFields[key].value)
                                    }
                                    if(isJSON(y.taskFields[key].value)) {
                                        y.taskFields[key].value = JSON.parse(y.taskFields[key].value)
                                    }
                                    if(storedSortState == 'ASC') {
                                        return x.taskFields[key].value.name > y.taskFields[key].value.name ? 1 : -1
                                    } else {
                                        return x.taskFields[key].value.name < y.taskFields[key].value.name ? 1 : -1
                                    }
                                }
                            })
                        })
                    })
                })
                break
            default:
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.forEach((task, key) => {
                        task.taskFields.forEach((taskField, key) => {
                            deliverable.tasks.sort((x, y) => {
                                if(taskField.field_id != payload.fieldId) return

                                // START new task type sorting
                                if(x.task_type_id > y.task_type_id){
                                    return 1;
                                }
                                if(y.task_type_id > x.task_type_id){
                                    return -1;
                                }
                                // END new task type sorting

                                if(x.taskFields[key].value === null || x.taskFields[key].value === '') {
                                    return 1
                                } 
                                if(y.taskFields[key].value === null || y.taskFields[key].value === '') {
                                    return -1
                                } 
                                if(storedSortState == 'ASC') {
                                    return (x.taskFields[key].value > y.taskFields[key].value) ? 1 : -1
                                } else {
                                    return (x.taskFields[key].value < y.taskFields[key].value) ? 1 : -1
                                }
                            })
                        })
                    })
                })
                break
        }
        if(!isDeliverableArray) {
            payload.deliverables = payload.deliverables[0]
        }
        if(typeof payload.return != 'undefined') {
            return isDeliverableArray ? payload.deliverables : payload.deliverables[0]
        }
    }
}

const sortTaskFields = (payload) => {
    let order = []
    if(!payload.fieldOrderData) {
        order = store.state.deliverables.storedTaskFieldsOrder
    } else {
        order[payload.deliverableTemplateId] = []
        payload.fieldOrderData.forEach((val, key) => {
            order[payload.deliverableTemplateId].push(val.field_id)
        })
        store.state.deliverables.storedTaskFieldsOrder = order
    }
    //console.log(order)
    
    store.state.deliverables.storedTaskFieldsOrder = order
    let deliverableTemplateId = ''
    if(router.currentRoute.name == 'dashboard') {
        if(typeof store.state.deliverables.deliverables != 'undefined') {
            for (let x = 0; x < Object.keys(store.state.deliverables.deliverables).length; x++) {
                deliverableTemplateId = store.state.deliverables.deliverables[x].deliverable_template_id
                if (typeof store.state.deliverables.deliverables[x] != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
                    for(let y = 0; y < store.state.deliverables.deliverables[x].tasks.length; y++) {
                        store.state.deliverables.deliverables[x].tasks[y].taskFields.sort((a, b) => {
                            var A = a['field_id'], B = b['field_id'];
                            return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
                        })
                    }
                }
            }
        }
    }

    if(router.currentRoute.name == 'myWeek') {
        if (typeof store.state.deliverables.unGroupedUserDeliverables.data != "undefined" && store.state.deliverables.unGroupedUserDeliverables.data.length) {
            for (let x = 0; x < Object.keys(store.state.deliverables.unGroupedUserDeliverables.data).length; x++) {
                deliverableTemplateId = store.state.deliverables.unGroupedUserDeliverables.data[x].deliverable_template_id
                if (typeof store.state.deliverables.unGroupedUserDeliverables.data[x] != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
                    for(let y = 0; y < store.state.deliverables.unGroupedUserDeliverables.data[x].tasks.length; y++) {
                        store.state.deliverables.unGroupedUserDeliverables.data[x].tasks[y].taskFields.sort((a, b) => {
                            var A = a['field_id'], B = b['field_id'];
                            return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
                        })
                    }
                }
            }
        }
    }
    
    if(router.currentRoute.name == 'projectDeliverable' || router.currentRoute.name == 'project' || router.currentRoute.name == 'myProjects') {
        if(typeof store.state.deliverables.projectDeliverables != 'undefined') {
            for (let x = 0; x < Object.keys(store.state.deliverables.projectDeliverables).length; x++) {
                deliverableTemplateId = store.state.deliverables.projectDeliverables[x].deliverable_template_id
                if (typeof store.state.deliverables.projectDeliverables[x] != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
                    for(let y = 0; y < store.state.deliverables.projectDeliverables[x].tasks.length; y++) {
                        store.state.deliverables.projectDeliverables[x].tasks[y].taskFields.sort((a, b) => {
                            var A = a['field_id'], B = b['field_id'];
                            return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
                        })
                    }
                }
            }
        }
    }

    deliverableTemplateId = store.state.deliverables.deliverableDetail.deliverable_template_id
    if (typeof store.state.deliverables.deliverableDetail != "undefined" && typeof store.state.deliverables.deliverableDetail.tasks != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
        for(let y = 0; y < store.state.deliverables.deliverableDetail.tasks.length; y++) {
            store.state.deliverables.deliverableDetail.tasks[y].taskFields.sort((a, b) => {
                var A = a['field_id'], B = b['field_id'];
                return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
            })
        }
    }
}
export { sortTasks, sortTaskFields }